interface Props {
  days: Date[]
  onPrev: () => void
  onNext: () => void
  onToday: () => void
}

const MONTH_FORMATTER = new Intl.DateTimeFormat('de-DE', { month: 'long', year: 'numeric' })

export const CalendarHeader = ({ days, onPrev, onNext, onToday }: Props) => {
  const mid = days[1]
  const label = MONTH_FORMATTER.format(mid)
  const capitalised = label.charAt(0).toUpperCase() + label.slice(1)

  return (
    <div className="flex items-center gap-2 px-3 py-3 bg-white border-b border-gray-200 relative z-30">
      <button
        onClick={onToday}
        className="text-base font-semibold text-[#124093] mr-1"
      >
        Heute
      </button>
      <button
        onClick={onPrev}
        className="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 text-gray-600 text-lg"
      >
        ‹
      </button>
      <button
        onClick={onNext}
        className="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 text-gray-600 text-lg"
      >
        ›
      </button>
      <span className="text-xl font-semibold text-gray-800 ml-1">{capitalised}</span>
    </div>
  )
}
